export default "__VITE_ASSET__CRQn$Knm__"